import request from '@/utils/http';

// 结算申请详情页
export const getSettleDetailLists = (params) => {
    return request({
        url: '/api-bms-web/apApply/listApapply',
        method: 'get',
        params
    });
};

// 提交付款申请
export const submitPayment = (params) => {
    return request({
        url: `/api-bms-web/efapBill/submitPaymentHandler`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: params
    });
};

// 校验发票开票人和付款单供应商是否一致
export const checkApplySupIsEqualOpenInvoiceCompany = (params) => {
    return request({
        url: `/api-bms-web/apApply/checkApplySupIsEqualOpenInvoiceCompany`,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        isBypassErrHandling: true,
        data: params
    });
};

// 保存
export const saveApply = (params) => {
    return request({
        url: `/api-bms-web/apApply/saveApply`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: params
    });
};

// 提交付款申请
export const submitApply = (params) => {
    return request({
        url: `/api-bms-web/apApply/submitApply
        `,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: params
    });
};

// 撤回提交付款申请
export const recallApply = (params) => {
    return request({
        url: `/api-bms-web/apApply/recallApply`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: params
    });
};

export const getFillLists = (params) => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/queryInvoiceInfo`,
        method: 'get',
        params
    });
};

// 发票删除
export const deleteInvoice = (params) => {
    return request({
        url: `/api-bms-web/apApply/deleteInvoice`,
        method: 'get',
        params
    });
};

// 发票修改
export const saveInvoice = (data) => {
    return request({
        url: `/api-bms-web/apApply/saveInvoice`,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    });
};

// 发票寄出
export const invoiceOperation = (data) => {
    return request({
        url: `/api-bms-web/apApply/invoiceOperation`,
        method: 'post',
        data
    });
};
// 作废结算
export const cancelApply = (data) => {
    return request({
        url: `/api-bms-web/apApply/cancelApply`,
        method: 'post',
        data
    });
};
// 作废结算-智慧开票时
export const cancelApplyE = (data) => {
    return request({
        url: `/api-bms-web/eis/cancelApply`,
        method: 'post',
        data
    });
};

// 发票列表

export const getInvoiceInfo = (params) => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/queryInvoiceInfo`,
        method: 'get',
        params
    });
};

export const pageSuppBank = (params) => {
    return request({
        url: '/api-bms-web/apApply/pageSuppBank',
        method: 'get',
        params
    });
};
// 附件列表
export const getAccessoryList = (params) => {
    return request({
        url: '/api-bms-web/apApply/listAnnexes',
        method: 'get',
        params
    });
};
// 附件上传
export const getSaveAnnexes = (data) => {
    return request({
        url: `/api-bms-web/apApply/saveAnnexes`,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    });
};
// 附件删除
export const getDeleteAnnexes = (data) => {
    return request({
        url: `/api-bms-web/apApply/deleteAnnexes`,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    });
};
export const getVisualization = (params) => {
    return request({
        url: '/api-bms-web/apApply/visualization',
        method: 'get',
        params
    });
};
// 生成发票前置处理接口
export const generateInvoicePreDeal = (data) => {
    return request({
        url: '/api-bms-web/eis/generateInvoicePreDeal',
        method: 'post',
        data
    });
};
// 生成发票
export const genExtsysInvoice = (params) => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/genExtsysInvoice?openInvoiceType=${params.openInvoiceType}&apApplyNo=${params.apApplyNo}`,
        method: 'get'
    });
};
// 发票红冲
export const redFlushInvoice = (data) => {
    return request({
        url: '/api-bms-web/eis/redFlushInvoice',
        method: 'post',
        data
    });
};

// 发票重开
export const reissueInvoice = (data) => {
    return request({
        url: '/api-bms-web/eis/reissueInvoice',
        method: 'post',
        data
    });
};

// 上传和保存发票接口
export const uploadAndSaveInvoice = (data) => {
    return request({
        url: '/api-bms-web/eis/uploadAndSaveInvoice',
        method: 'post',
        data
    });
};

// 查询生成发票相关信息
export const relateInfoOfExtsysInvoice = (params) => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/relateInfoOfExtsysInvoice',
        method: 'get',
        params
    });
};
// 点击申请提前付款接口
export const paymentCheck = (data) => {
    return request({
        url: `/api-bms-web/apApply/paymentCheck`,
        method: 'post',
        data
    });
};
// 提前收款申请界面接口 ?apApplyNo=AA20230213920287
export const paymentSubmit = (params) => {
    return request({
        url: '/api-bms-web/apApply/paymentSubmit',
        method: 'get',
        params
    });
};
// 协议和申请书预览接口
export const downloadPdf = (data) => {
    return request({
        url: `/api-bms-web/apApply/downloadPdf`,
        method: 'post',
        data
    });
};
// 申请提前收款页签列表 ?apApplyNo=AA202404031595022
export const queryApplyChange = (params) => {
    return request({
        url: '/api-bms-web/apApply/queryApplyChange',
        method: 'get',
        params
    });
};
// 电子签章
export const pushElectronic = (data) => {
    return request({
        url: `/api-bms-web/apApply/pushElectronic`,
        method: 'post',
        data
    });
};
// 电子签章撤回
export const recallApElectronic = (data) => {
    return request({
        url: `/api-bms-web/apApply/recallApElectronic`,
        method: 'post',
        data
    });
};
// 信息变更单提交操作
export const submitApplyChange = (data) => {
    return request({
        url: `/api-bms-web/apApply/submitApplyChange`,
        method: 'post',
        data
    });
};
// 废弃
export const abolishApplyChange = (data) => {
    return request({
        url: `/api-bms-web/apApply/abolishApplyChange`,
        method: 'post',
        data
    });
};
// 查询系统参数
export const querySysParam = (data) => {
    return request({
        url: `/api-bms-web/apApply/querySysParam?sysCode=BMS_ZRB_ONLINE_COMPANY_CODE`,
        method: 'get'
    });
};